module.exports = __webpack_public_path__ + "785fd9261d71ec45be0e8ff5ddd790c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-panel-768.jpg
// module id = 381
// module chunks = 0